// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Avatar, Button, Col, Tag } from "antd";
import { Edit, Trash2, Eye, ArrowRightLeft } from "lucide-react";
import { TableProductCategoriesSortable } from "./TableProductCategoriesSortable";
import lodash from "lodash";

import { TableColumns } from "../../../shared/components/ui/Table/types";
import { IProductCategory } from "../../../redux/@types";
import { useTableProductCategories, useProductCategories } from "../hooks";
import { ModalTransferProducts } from "./ModalTransferProducts";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";
import { LucideIcon } from "../../../shared/components/ui/icons/LucideIcon";
interface Props {
  parent_id?: number;
}

export const TableProductCategories = ({ parent_id }: Props) => {
  const {
    navigateSingleCategory,
    showDeleteConfirm,
    changeProductCategoriesForUpdate,
    openTransferModal,
    closeTransferModal,
    transferModalOpen,
    transferSourceCategory,
  } = useTableProductCategories();
  const { setTableProps, updateStatus, isLoading } = useProductCategories();
  const columns: TableColumns<IProductCategory> = [
    {
      title: "ID",
      width: 2,
      dataIndex: "id",
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Imagen",
      width: 3,
      dataIndex: "imagen",
      key: "imagen",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar 
              size={64} 
              shape="square"
              src={item.path_image ? `${PATH_S3_BUCKET}/${item.path_image}` : null}
              style={{
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                backgroundColor: "#f7fafc",
                color: "#718096",
              }}
            >
              {!item.path_image && "Sin foto"}
            </Avatar>
          </Col>
        );
      },
    },
    {
      title: "Nombre",
      width: 6,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Productos",
      width: 2,
      dataIndex: "products_count",
      key: "products_count",
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontWeight: 500 }}>
            {item.products_count ?? 0}
          </span>
        </Col>
      ),
    },
    {
      title: "Estado",
      width: 3,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tag
              color={item.status === "active" ? "success" : "error"}
              style={{
                borderRadius: "6px",
                padding: "4px 12px",
                fontSize: "13px",
                fontWeight: 500,
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.6 : 1,
              }}
              onClick={() => {
                if (!isLoading) {
                  if (item.status === "active") {
                    updateStatus("inactive", item.id);
                  } else if (item.status === "inactive") {
                    updateStatus("active", item.id);
                  }
                }
              }}
            >
              {item.status === "active" ? "Activo" : "Inactivo"}
            </Tag>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },

    !parent_id && {
      title: "Categorías anidadas",
      width: 3,
      key: "show_sons",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="text"
              onClick={() => navigateSingleCategory(item)}
              style={{
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px",
              }}
            >
              <LucideIcon>
                <Eye size={18} />
              </LucideIcon>
            </Button>
          </Col>
        );
      },
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 1,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {(item.products_count ?? 0) > 0 && (
              <Button
                type="text"
                onClick={() => openTransferModal(item)}
                title="Transferir productos"
                style={{
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px",
                }}
              >
                <LucideIcon>
                  <ArrowRightLeft size={18} />
                </LucideIcon>
              </Button>
            )}
            <Button
              type="text"
              onClick={() => changeProductCategoriesForUpdate(item)}
              style={{
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px",
              }}
            >
              <LucideIcon>
                <Edit size={18} />
              </LucideIcon>
            </Button>
            <Button
              type="text"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              style={{
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px",
              }}
            >
              <LucideIcon>
                <Trash2 size={18} />
              </LucideIcon>
            </Button>
          </Col>
        );
      },
    },
  ];
  const filteredColumns = lodash.filter(columns);

  return (
    <>
      <TableProductCategoriesSortable
        columns={filteredColumns}
        parent_id={parent_id}
        onLoad={setTableProps}
      />
      <ModalTransferProducts
        open={transferModalOpen}
        onClose={closeTransferModal}
        sourceCategory={transferSourceCategory}
      />
    </>
  );
};
